import Vue from 'vue'
import VueRouter from 'vue-router'
import ScoreList from './components/ScoreList.vue'
import TowerList from './components/TowerList.vue'
import CommentList from './components/CommentList.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/score',
    },
    {
        path: '/score/:page?',
        name: 'score',
        component: ScoreList,
    },
    {
        path: '/tower/:page?',
        name: 'tower',
        component: TowerList,
    },
    {
        path: '/comment/:page?',
        name: 'comment',
        component: CommentList,
    },
]

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.name) { // 首次进入不处理
        if (!to.params.page) to.params.page = 1;
    }
    next();
})

export default router
